import { Box, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import Main from './variants/agent/Main';
import ReactLoading from 'react-loading';
import { generateClient } from 'aws-amplify/api';
import { Schema } from '../../../amplify/data/resource';

// @ts-ignore
type Agent = Schema['User']['type'];

const apiClient = generateClient<Schema>();

const Agent = ({ userId }: { userId: string }) => {
  const theme = useTheme();

  const [agent, setAgent] = useState<Agent | null>(null);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState('main');

  useEffect(() => {
    if (!userId) {
      return;
    }
    const fetchUser = async () => {
      setLoading(true);

      try {
        const response = await apiClient.models.User.get({ id: userId });

        setAgent(response.data);
      } catch (error) {
        console.error('Error downloading agent info:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [userId]);

  return (
    <Box>
      {loading || agent === null ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            backgroundColor: '#E7ECF2',
          }}
        >
          <ReactLoading
            type={'bubbles'}
            color={theme.palette.green.main}
            height={250}
            width={250}
          />
        </Box>
      ) : (
        <Main agent={agent} />
      )}
    </Box>
  );
};

export default Agent;
